module.exports = __webpack_public_path__ + "img/ic_services_parking.2253e204.svg";